var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "checkbox_group d-flex" }, [
    _c(
      "div",
      { staticStyle: { flex: "1 1 0" } },
      [
        _vm.task.status === "DONE"
          ? [
              _c("input", {
                attrs: {
                  type: "checkbox",
                  checked: "",
                  disabled: _vm.readonly || _vm.lockeddown
                },
                on: {
                  change: function($event) {
                    return _vm.toggle(false)
                  }
                }
              })
            ]
          : [
              _c("input", {
                attrs: {
                  type: "checkbox",
                  disabled: _vm.readonly || _vm.lockeddown
                },
                on: {
                  change: function($event) {
                    return _vm.toggle(true)
                  }
                }
              })
            ],
        _vm._v("\n        " + _vm._s(_vm.task.name) + "\n    ")
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex flex-row align-items-center" }, [
      _c(
        "div",
        {
          staticClass: "d-inline-block text-right text-truncate",
          staticStyle: { width: "8em" }
        },
        [_vm._v(_vm._s(_vm.task.description ? _vm.task.description : ""))]
      ),
      _vm._v(" "),
      !_vm.readonly && !_vm.lockeddown
        ? _c("i", {
            staticClass: "fas fa-edit p-cursor ml-2",
            on: { click: _vm.edit }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.readonly && !_vm.lockeddown
        ? _c("i", {
            staticClass: "fas fa-times p-cursor ml-2",
            on: { click: _vm.remove }
          })
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }